import {
  AfterViewInit,
  Component,
  HostListener,
  inject,
  signal,
  viewChild
} from '@angular/core';

import {
  ContextMenuComponent,
  ContextMenuOption
} from '@shared/components/context-menu/context-menu.component';
import { DropdownSingletonComponent } from '@shared/components/dropdown-singleton/dropdown-singleton.component';
import { DropdownService } from '@shared/components/dropdown-singleton/dropdown.service';
import { TooltipSingletonComponent } from '@shared/components/tooltip-singleton/tooltip-singleton.component';
import { TooltipService } from '@shared/components/tooltip-singleton/tooltip.service';
import {
  ContextMenuHeader,
  ContextMenuService
} from '@shared/services/context-menu/context-menu.service';

@Component({
  selector: 'app-overlay-host',
  imports: [TooltipSingletonComponent, DropdownSingletonComponent, ContextMenuComponent],
  templateUrl: './overlay-host.component.html',
  styles: ``
})
export class OverlayHostComponent implements AfterViewInit {
  private readonly tooltipService = inject(TooltipService);
  private readonly dropdownService = inject(DropdownService);
  private readonly contextMenuService = inject(ContextMenuService);

  contextMenuOptions = signal<ContextMenuOption[]>([]);
  contextMenuHeader = signal<ContextMenuHeader | null>(null);
  contextMenuX = signal<number>(0);
  contextMenuY = signal<number>(0);
  isContextMenuOpen = signal(false);

  tooltip = viewChild<TooltipSingletonComponent>('tooltip');
  dropdown = viewChild<DropdownSingletonComponent>('dropdown');

  ngAfterViewInit(): void {
    if (this.tooltip()) {
      this.tooltipService.register(this.tooltip()!);
    }
    if (this.dropdown()) {
      this.dropdownService.register(this.dropdown()!);
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent): void {
    event.preventDefault();
    const rawTarget = event.target as HTMLElement;
    const target = this.findContextElement(rawTarget);

    if (target) {
      this.contextMenuOptions.set(this.contextMenuService.getOptions(target));
      this.contextMenuHeader.set(this.contextMenuService.getHeader(target) ?? null);
    } else {
      this.contextMenuOptions.set([]);
      this.contextMenuHeader.set(null);
    }

    this.contextMenuX.set(event.clientX);
    this.contextMenuY.set(event.clientY);
    this.isContextMenuOpen.set(true);
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event?: MouseEvent): void {
    const target = event?.target;
    if (target instanceof Element && target.closest('app-context-menu')) {
      return;
    }

    this.isContextMenuOpen.set(false);
  }

  findContextElement(target: HTMLElement | null): HTMLElement | null {
    while (target && !target.hasAttribute('data-context')) {
      target = target.parentElement;
    }
    return target;
  }
}
